"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractEntityRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.ContractEntityRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.contract_entity.label',
    fallbackLabel: 'Contractual entity',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'KLARNA_AB', label: 'fields.enm.contract_entity.options.KLARNA_AB', fallbackLabel: 'Klarna Bank AB' },
        { key: 'KLARNA_AU', label: 'fields.enm.contract_entity.options.KLARNA_AU', fallbackLabel: 'Klarna Australia Pty Ltd' },
        { key: 'KLARNA_CA', label: 'fields.enm.contract_entity.options.KLARNA_CA', fallbackLabel: 'Klarna Canada Limited' },
        { key: 'KLARNA_INC', label: 'fields.enm.contract_entity.options.KLARNA_INC', fallbackLabel: 'Klarna Inc' },
        { key: 'KLARNA_NZ', label: 'fields.enm.contract_entity.options.KLARNA_NZ', fallbackLabel: 'Klarna NZ Limited' },
        { key: 'KLARNA_DEB', label: 'fields.enm.contract_entity.options.KLARNA_DEB', fallbackLabel: 'Klarna Bank AB, German Branch' },
        { key: 'KLARNA_UKB', label: 'fields.enm.contract_entity.options.KLARNA_UKB', fallbackLabel: 'Klarna Bank AB, UK Branch' },
        { key: 'KLARNA_FRB', label: 'fields.enm.contract_entity.options.KLARNA_FRB', fallbackLabel: 'Klarna Bank AB, French Branch' },
        { key: 'KLARNA_MX', label: 'fields.enm.contract_entity.options.KLARNA_MX', fallbackLabel: 'Klarna Mexico' },
        { key: 'S_KCO', label: 'fields.enm.contract_entity.options.S_KCO', fallbackLabel: 'Neo - Acquiring contract entity for KCO merchants' },
    ],
    trackFieldValueWithAnalytics: false,
};
